"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateFieldValue = exports.updateLayoutJson = exports.initLayoutJson = exports.updateModule = exports.updateUserProfile = undefined;

var _actionTypes = require("./actionTypes");

var updateUserProfile = exports.updateUserProfile = function updateUserProfile(updatedProfile) {
    return {
        type: _actionTypes.UPDATE_USER_PROFILE,
        payload: updatedProfile
    };
};

var updateModule = exports.updateModule = function updateModule(updateData) {
    return {
        type: _actionTypes.UPDATE_MODULE,
        payload: updateData
    };
};

var initLayoutJson = exports.initLayoutJson = function initLayoutJson(json) {
    return {
        type: _actionTypes.INIT_LAYOUT_JSON,
        payload: json
    };
};

var updateLayoutJson = exports.updateLayoutJson = function updateLayoutJson(json) {
    return {
        type: _actionTypes.UPDATE_LAYOUT_JSON,
        payload: json
    };
};

var updateFieldValue = exports.updateFieldValue = function updateFieldValue(statePath, value) {
    return {
        type: _actionTypes.UPDATE_FIELD_VALUE,
        payload: { statePath: statePath, value: value }
    };
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/module/action.js
// module id = 2153
// module chunks = 1137